import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StepperService } from 'src/app/stepper.service';


@Component({
  selector: 'x-p-steps',
  templateUrl: './p-steps.component.html',
  styleUrls: ['./p-steps.component.scss']
})
export class PStepsComponent implements OnInit {

  currentStep: number;
  @Input("model") model: any;
  @Input("component") component: any;
  @Input("notShowReservation") notShowReservation: boolean = false;

  showStepper: boolean = true;
  constructor(private stepperService: StepperService, private router: Router ) {   }

  ngOnInit(): void {
  
    this.showStepper = true;

    this.stepperService.currentStep.subscribe(step => {
      this.showStepper = true;
      this.currentStep = step
      if(this.currentStep == 4) this.showStepper = false;
      if(this.currentStep == 3 && this.model && !this.model.selectedProduct) this.showStepper = false;
    });
  }


  goToStep(step: number) {
    if(this.currentStep == 1) this.router.navigate(['/home']);
    if(step > this.currentStep) return;
    if(this.currentStep > 2) return;

    this.currentStep = step;
    this.stepperService.changeCurrentStep(step);

  }
  showLastStep() {
    if(this.currentStep == 3 && (!this.component.model.selectedProduct || this.component.model.offerSubStatus == 'PO')) return false;
    return true;
  }

}
